import { maxInt } from "src/ui/utils/limit";

export function isLimitReached(value: number, max: number) {
    if (max !== maxInt && max !== Infinity) {
        return max !== 0 && value >= max;
    }
    return false;
}
